<script>
export default {
    name: "ButtonMobileNext"
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="80.552" height="40.102" viewBox="0 0 80.552 40.102">
        <g id="Group_1510" data-name="Group 1510" transform="translate(-281.601 -2874.371)">
            <g id="Group_1478" data-name="Group 1478" transform="translate(281.601 2874.371)">
                <g id="Group_938" data-name="Group 938" transform="translate(40.451)">
                    <path id="Path_1070" data-name="Path 1070" d="M0,0,16.663,16.663,33.327,0" transform="translate(8.95 36.596) rotate(-90)" fill="none" stroke="#000" stroke-width="1"/>
                    <g id="Ellipse_48" data-name="Ellipse 48" fill="none" stroke="#000" stroke-width="1">
                        <ellipse cx="20.051" cy="20.051" rx="20.051" ry="20.051" stroke="none"/>
                        <ellipse cx="20.051" cy="20.051" rx="19.551" ry="19.551" fill="none"/>
                    </g>
                </g>
                <text id="Next" transform="translate(0 21.863)" font-size="10" font-family="Apertura-Medium, Apertura" font-weight="500" letter-spacing="0.1em"><tspan x="0" y="0">Next</tspan></text>
            </g>
        </g>
    </svg>
</template>